import React, {useState} from "react";
import { motion } from "framer-motion";
import { ChartBarIcon, BriefcaseIcon } from "@heroicons/react/24/outline";
//25 Nov 2025
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";

const segments = [
  {
    id: "pe-firms",
    icon: BriefcaseIcon,
    title: "Private Equity Firms",
    // desc: "We partner with PE leadership to align technology portfolio strategy, unlock performance synergies, and accelerate value creation across investments.", // 25 Oct 2025
    // desc: "We partner with PE leadership to uncover growth bottlenecks within tech-led portfolio companies. Our work addresses underlying mindset, communication, and client-engagement challenges that limit performance leverage.",
    desc: "We partner with PE leadership to uncover growth bottlenecks within tech-led portfolio companies. Our work addresses client-engagement challenges that limit performance leverage.",
    bullets: [
      // "Portfolio-wide digital transformation strategy",
      // "Value creation roadmaps & leadership alignment",
      // 25 Oct 2025
      // "Portfolio-wide growth performance diagnostics",
      "Consultative performance diagnostics for portcos",
      // "Leadership alignment for scalable influence",
      "Replicable growth performance roadmaps",
      "Performance visibility powered by Trinity AI",

    ],
  },
  {
    id: "sme-tech",
    icon: ChartBarIcon,
    // title: "SME Tech Services Companies", // 25 Oct 2025
    // title: "SME Tech Led Companies", // 25 Oct 2025
    title: "Tech Led Companies", // 05 Dec 2025
    // desc: "We help founders and CEOs of tech led firms scale with purpose — strengthening vision, execution discipline, and leadership leverage.",
    desc: "We help founders and CEOs of tech-led firms scale with purpose. Our focus is on strengthening vision, execution discipline, and leadership leverage.",
    bullets: [
      "Vision–Mission–Plan cascade design",
      // "Leadership alignment & talent performance systems", // 25 Oct 2025
      "Leadership alignment on performance markers", // 25 Oct 2025
      // "Growth cohorts: IgnitiON, FusiON, AscensiON", // 25 Oct 2025
      "Growth cohorts powered by Trinity AI", // 25 Oct 2025
    ],
  },
];

const EtClientsSegments = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey
  // Updated - 25 Nov 2025 - Refined for Unified CTA - ctaSource
  
  // 1 -  Local UI state 
  const [open, setOpen] = useState({ visible: false, source: null }); // 25 Nov 2025 - unified CTA

  return (
    <section
      id="segments"
      className="py-20 bg-black text-white border-t border-white/10 font-poppins"
    >
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Heading */}
        <motion.h2
          className="text-3xl md:text-4xl font-bold mb-12 text-center text-orange-600"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Who We Work With
        </motion.h2>

        {/* Framing Intro */}
        <motion.p
          className="text-gray-300 max-w-xl mx-auto text-center mb-16 text-xl md:text-2xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          {/* Eternity partners with two kinds of leaders shaping the future of tech services — 
          those <span className="text-orange-500">who invest in growth</span>, and those <span className="text-orange-500">who live it</span> every day. */}
          Eternity partners with two kinds of leaders shaping the future of tech-led organizations.
          Those <span className="text-orange-500">who invest in growth</span>, and those <span className="text-orange-500">who live it</span> every day.
        </motion.p>

        {/* Segment Panels */}
        <div className="grid md:grid-cols-2 gap-10">
          {segments.map((seg, i) => (
            <motion.div
              key={seg.id}
              className="p-8 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 transition shadow-lg flex flex-col justify-between"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.2, duration: 0.7 }}
            >
              {/* Header */}
              <div>
                <seg.icon className="h-10 w-10 text-orange-500 mb-4" />
                <h3 className="text-2xl font-semibold mb-3">{seg.title}</h3>
                <p className="text-gray-300 mb-6">{seg.desc}</p>

                {/* Bullets */}
                <ul className="space-y-3">
                  {seg.bullets.map((b, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-gray-400 text-sm"
                    >
                      <span className="text-orange-500">•</span>
                      {b}
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <div className="mt-8">
                <a
                  // href="#contact"
                  onClick={() => setOpen({ visible: true, source: "clients-segments" })} // 25 Nov 2025
                  className="inline-block px-6 py-3 rounded-lg bg-orange-600 text-white font-semibold hover:bg-orange-700 transition cursor-pointer"
                >
                  Connect with Us
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Reflection Bridge */}
        {/* <motion.p
          className="text-gray-400 text-center mt-16 text-2xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Where does your growth story begin? Scroll down to explore the key states of CxO evolution.
        </motion.p> */}
      </div>
      {/* 25 Nov 2025 */}
      {open.visible && (
        <EtModalContactConversation
          open={open}
          onClose={() => setOpen({ visible: false, source: null })}
        />
      )}


    </section>
  );
};

export default EtClientsSegments;